import Divider from "components/ui/divider"
import Shimmer from "components/ui/shimmer"

import { GridContainer } from "../products"
import Placeholder from "../products/placeholder"

const Shimmers = () => (
  <div className="contained-wide">
    {/* <div
      className="aspect-(--base-aspect-ratio) tablet:aspect-(--tablet-aspect-ratio)"
      style={{
        "--base-aspect-ratio": "750 / 200",
        "--tablet-aspect-ratio": "3840 / 564",
      }}
    >
      <Shimmer className="h-full w-full" />
    </div> */}
    <div className="px-16">
      <div className="my-16">
        <Shimmer className="mb-16" style={{ height: "16px", width: "200px" }} />
        <div className="flex justify-between">
          <div className="desktop:w-3/4 w-full">
            <Shimmer
              className="desktop:w-(--desktop-width) w-(--base-width) h-(--base-height) tablet:h-(--tablet-height) widescreen:h-(--widescreen-height) mb-10"
              style={{
                "--base-height": "22px",
                "--base-width": "200px",
                "--desktop-width": "400px",
                "--tablet-height": "24px",
                "--widescreen-height": "28px",
              }}
            />
            <Shimmer
              className="desktop:h-(--desktop-height) h-(--base-height) w-full"
              style={{
                "--base-height": "60px",
                "--desktop-height": "36px",
              }}
            />

            {/* <Media lessThan="desktop">
              <Shimmer
                className="mt-8"
                style={{ height: "12px", width: "300px" }}
              />
            </Media> */}
          </div>

          {/* <Media greaterThanOrEqual="desktop">
            <Shimmer style={{ height: "20px", width: "130px" }} />
          </Media> */}
        </div>
      </div>
      <Divider className="mb-4" />
      <div className="flex justify-between py-3">
        <Shimmer style={{ height: "26px", width: "70px" }} />
        <Shimmer style={{ height: "26px", width: "135px" }} />
      </div>
      <Divider className="mt-4" />
      <div className="desktop:pt-0 pt-24">
        <GridContainer>
          {[...Array(12)].map((_, i) => (
            <Placeholder index={i} key={`placeholder-${i}`} />
          ))}
        </GridContainer>
      </div>
    </div>
  </div>
)

export default Shimmers
